
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shop]/login",
      function () {
        return require("private-next-pages/[shop]/login/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shop]/login"])
      });
    }
  